
<script>
	import listBase from '@_system/components/base/list.vue'
	import editIndex from './edit/index.vue'
	export default {
		extends: listBase,
		name: 'purchaserelationflowIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'purchaserelationflow',
				windowName: '现结流水关联',
				windowType: 'modal',
				currentrow:null,
				list_footerField:[
					{field:'amt',toFixed:2}
				],
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500,2000],
				},
				importTableRef:Math.random(),
				importTableModuleName:null,
				importTablepredata:[]
			}
		},
		render(h) {
			this.$slots.mainheader = [
				<el-tag type="danger" size="mini">关联单据限制 只允许导入【CD单/CT单/未入库/UT(转账单编码)】</el-tag>,
			]
			this.$slots.plug = [
				<edit-index ref="editIndex" row={this.currentrow} onSuccess={this.success} />,
				<importTable ref={this.importTableRef} moduleName={this.importTableModuleName} importpredata={this.importTablepredata}  />
			]
			return listBase.render.call(this, h)
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.$refs[this.importRef].importcomfig = this.importcomfig
			this.$refs[this.importRef].moduleImport = this.moduleImport
			
		},
		computed: {

		},

		methods: {
			importcomfig(){
				let res =[{
					code:'purchaserelationflow',
					config:'update',
					configtype:'custom',
					name:'现结流水关联',
					columns:[{
						config:['unique'],
						field:'main|serialId',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow',
						tablename:'主表',
						tabletype:'son',
						title:'序列号ID',
					},{
						config:['require'],
						field:'main|serialNo',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow',
						tablename:'主表',
						tabletype:'son',
						title:'关联单据',
					}]
				}]
				return Promise.resolve(res) 
			},
			moduleImport(formData) {
				return new Promise((reslove,reject)=>{
					this.$api[this.moduleName].import(formData).then((res)=>{
						reslove(res)						
					},()=>{
						reject()
					})
				})				
			},
			edit(row) {
				this.currentrow = row
				this.$refs.editIndex.modalShow()
				console.log(row)
				//alert(1)
			},
			success(){
				this.$refs[this.moduleName + '_list'].commitProxy('query')
			},
			tocostorder(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}	
				this.createcostorder(data)
			},
			createcostorder(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				this.importTablepredata = row.map((item)=>{
					let company = window.systemData.company.find((_item)=>{
						return _item.name == item.accName
					})
					return {
						'main|bankAcc':item.bankAcc,
						'main|rcvAcc':item.oppAccNo,
						'main|serialId':item.serialId,
						'main|paymenttime':item.transTime,
						'main|biztime':item.transTime,
						'main|companyid':company?company.id:null,
						'costorder_detail|businessdepartmentid':null,
						'costorder_detail|costamount':item.cdSign == 0 ? -item.amt : item.amt
					}
				})
				this.importTableModuleName = 'costorder'
				this.$refs[this.importTableRef].importpanel()
			},
			
			// importcomfig(){
			// 	return new Promise((reslove)=>{
			// 		let res = [
			// 			{code:'serialId',title:'序列号ID',require:true},
			// 			{code:'serialNo',title:'关联单据'}
			// 		]
			// 		reslove(res)
			// 	})
			// },
		},
		components: {
			editIndex	
		}
	}
</script>
